import { useThemeConstants } from "@/app/hooks/useThemeConstants";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { IButtonCore } from "../interface";

const ButtonCore: React.FC<React.PropsWithChildren<IButtonCore>> = ({
  size,
  onButtonClick,
  disabled,
  asLink,
  href,
  children,
  asType,
  type,
  asSubmitText,
  ...props
}) => {
  const {
    buttons: { sizes: buttonSizes, baseThemes },
  } = useThemeConstants();

  const handleClick = (e) => {
    if (disabled) return;
    if (onButtonClick) {
      onButtonClick(e);
    }
  };

  return asLink ? (
    <Link to={href} className={clsx(baseThemes[type], buttonSizes[size], props?.className)}>
      {children}
    </Link>
  ) : asType ? (
    asType === "button" ? (
      <button
        disabled={disabled ?? false}
        type={asType ?? "button"}
        onClick={handleClick}
        className={clsx(baseThemes[type], buttonSizes[size], props?.className)}
      >
        {children}
      </button>
    ) : (
      <input
        disabled={disabled ?? false}
        type="submit"
        value={asSubmitText}
        className={clsx("cursor-pointer", baseThemes[type], buttonSizes[size], props?.className)}
      />
    )
  ) : (
    <button
      disabled={disabled ?? false}
      type={asType ?? "button"}
      onClick={handleClick}
      className={clsx(baseThemes[type], buttonSizes[size], props?.className)}
    >
      {children}
    </button>
  );
};

export default ButtonCore;
